import { ofType } from "redux-observable";
import { mergeMap, debounceTime } from "rxjs/operators";
import { merge, of } from "rxjs";
import { GET_ORGANIZATION_LOGIN } from "../types";
import {
  getOrganizationLoginPending,
  getOrganizationLoginFulfilled,
  getOrganizationLoginRejected,
} from "../actions";
import { sendApiRequest, notifyError, notifyWarning } from "../../../actions";
import { ORGANIZATION_MESSAGES } from "../constants/organizationMessages";
import generateError from "../../../utilities/generateError";
const createPayload = (payload) => ({
  method: "post",
  url: "organization/GetOrganizationLoginRule",
  onSuccess: [
    (response) =>
      response.data.length === 0
        ? notifyWarning(ORGANIZATION_MESSAGES.NOT_FOUND)
        : getOrganizationLoginFulfilled(response),
  ],
  onError: [
    getOrganizationLoginRejected,
    (error) => notifyError(generateError(error)),
  ],
  data: payload,
});
const meta = {
  api: "ajaxApi",
};
const getOrganizationLoginEpic$ = (action$, state$) =>
  action$.pipe(
    ofType(GET_ORGANIZATION_LOGIN.DEFAULT),
    debounceTime(500),
    mergeMap(({ payload }) => {
      return merge(
        of(getOrganizationLoginPending()),
        of(sendApiRequest(createPayload({ ...payload }), meta))
      );
    })
  );
export default getOrganizationLoginEpic$;



// WEBPACK FOOTER //
// ./src/features/organization/epics/getOrganizationLoginEpic.js